import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { Brain, TrendingUp, AlertTriangle } from "lucide-react";

const mockData = [
  { month: 'Jan', riskScore: 65, threshold: 70 },
  { month: 'Feb', riskScore: 75, threshold: 70 },
  { month: 'Mar', riskScore: 68, threshold: 70 },
  { month: 'Apr', riskScore: 72, threshold: 70 },
  { month: 'May', riskScore: 80, threshold: 70 },
  { month: 'Jun', riskScore: 74, threshold: 70 },
];

const RiskAnalytics = () => {
  return (
    <div className="grid gap-6">
      <Card className="p-6">
        <h2 className="text-2xl font-semibold mb-6 flex items-center gap-2">
          <TrendingUp className="h-6 w-6" />
          Risk Score Trends
        </h2>
        <div className="h-[400px]">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={mockData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Line
                type="monotone"
                dataKey="riskScore"
                stroke="#8884d8"
                activeDot={{ r: 8 }}
              />
              <Line
                type="monotone"
                dataKey="threshold"
                stroke="#82ca9d"
                strokeDasharray="5 5"
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </Card>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Card className="p-6">
          <h3 className="text-xl font-semibold mb-4 flex items-center gap-2">
            <AlertTriangle className="h-5 w-5" />
            Risk Factors
          </h3>
          <ul className="space-y-4">
            <li className="flex items-center justify-between">
              <span>Credit Score Impact</span>
              <span className="font-semibold text-yellow-600">Medium</span>
            </li>
            <li className="flex items-center justify-between">
              <span>Transaction Pattern Risk</span>
              <span className="font-semibold text-green-600">Low</span>
            </li>
            <li className="flex items-center justify-between">
              <span>Document Verification Risk</span>
              <span className="font-semibold text-red-600">High</span>
            </li>
          </ul>
        </Card>

        <Card className="p-6">
          <h3 className="text-xl font-semibold mb-4 flex items-center gap-2">
            <Brain className="h-5 w-5" />
            AI Insights
          </h3>
          <div className="space-y-4">
            <p className="text-sm text-muted-foreground">
              AI-powered analysis has detected unusual patterns in recent transactions.
              Recommended actions have been generated for review.
            </p>
            <Button className="w-full">
              <Brain className="mr-2 h-4 w-4" />
              Generate Detailed Report
            </Button>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default RiskAnalytics;